import type { QueryClient } from "@tanstack/react-query";
import { ClassEnrollmentsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

const ENROLLMENTS_PAGE_SIZE = 1000;
const PREFETCH_STALE_TIME_MS = 5 * 60 * 1000;

export async function prefetchClassesEnrollmentsByStudentId(
  studentId: number,
  queryClient: QueryClient,
  accessToken: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching enrollments");
  }

  const service = createAuthenticatedApi(ClassEnrollmentsApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.ClassesEnrollmentsByStudentId, studentId],
    queryFn: () =>
      service.apiClassEnrollmentsStudentsIdGet({
        id: studentId,
        page: 1,
        pageSize: ENROLLMENTS_PAGE_SIZE,
      }),
    staleTime: PREFETCH_STALE_TIME_MS,
  });

  return queryClient;
}
